import {
  CallToAction,
  Iframe,
  Media,
  ResponsiveImage,
  Table,
  TagFragment,
  VideoExternal,
  Video
} from '~/graphql/fragments'

import {
  SectionContact,
  SectionHero,
  SectionLogos,
  SectionStructuredText,
  SectionLead,
  SectionStats,
  SectionHeroAbout,
  SectionServices,
  SectionProjects,
  SectionBigLead,
  SectionLocations,
  SectionFeaturedProjects,
  SectionAboutImage,
  SectionThumbnails,
  SectionOverview,
  SectionContentList,
  SectionTitle,
  SectionPush,
  SectionAnchor,
  SectionArticles
} from '~/graphql/fragments/sections'

export const queryPage = /* GraphQL */ `
  ${CallToAction}
  ${Iframe}
  ${Media}
  ${ResponsiveImage}
  ${Table}
  ${TagFragment}
  ${VideoExternal}
  ${Video}

  ${SectionContact}
  ${SectionHero}
  ${SectionLogos}
  ${SectionStructuredText}
  ${SectionLead}
  ${SectionStats}
  ${SectionHeroAbout}
  ${SectionServices}
  ${SectionProjects}
  ${SectionBigLead}
  ${SectionLocations}
  ${SectionFeaturedProjects}
  ${SectionAboutImage}
  ${SectionThumbnails}
  ${SectionOverview}
  ${SectionContentList}
  ${SectionTitle}
  ${SectionPush}
  ${SectionAnchor}
  ${SectionArticles}

  query Page($locale: SiteLocale, $slug: String) {
    page(locale: $locale, filter: { slug: { eq: $slug } }) {
      _seoMetaTags {
        ...TagFragment
      }
      _allSlugLocales {
        locale
        value
      }
      _allPublishTranslationLocales {
        value
        locale
      }
      _modelApiKey
      id
      slug
      title
      main {
        ... on RecordInterface {
          id
          __typename
          _modelApiKey
        }
        ...SectionContact
        ...SectionHero
        ...SectionLogos
        ...SectionStructuredText
        ...SectionLead
        ...SectionStats
        ...SectionHeroAbout
        ...SectionServices
        ...SectionProjects
        ...SectionBigLead
        ...SectionLocations
        ...SectionFeaturedProjects
        ...SectionAboutImage
        ...SectionThumbnails
        ...SectionOverview
        ...SectionContentList
        ...SectionTitle
        ...SectionPush
        ...SectionAnchor
        ...SectionArticles
      }
      publishTranslation
      seoMetadata {
        noIndex
      }
    }
  }
`
